import styled from "@emotion/styled"
import SideBarMontador from "../components/sidebar/SideBarMontador"
export default function MontadoraLayout({ children, sideBarOff }) {

  return (
    <Wrapper sideBarOff={sideBarOff}>
      <SideBarMontador sideBarOff={sideBarOff} />
      <main>
        {children}
      </main>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background-color: #F5F5F9;
  height: 100vh;
  
  & > main {
    background-color: #F5F5F9;
    margin-left: ${({ sideBarOff }) => !sideBarOff && "90px"};
    width: ${({ sideBarOff }) => !sideBarOff && "calc(100% - 90px)"};
    padding: 20px;
  }

  @media only screen and (max-width: 770px) {

   & > main {
     margin: 0;
     width: 100%;
   }
  }
`

